import { Row, Col, Pagination, Input, Select, message } from "antd";
import { useState, useEffect } from "react";
import { global_var } from "../../services/cs-lab-config";
import {
  loadClassRoomDetails,
  getDivisionDetails,
} from "../../services/ide-apis";

const LabAssignmentFilters = ({
  totalLabQuestionsCount,
  hideProjectStatusFilter,
  filtersChanged,
  hideAssignmentTypeFilter,
  searchBoxPlaceHolder,
  hideClassFilter,
  hideDivisionFilter,
}) => {
  const [filters, setFilters] = useState({
    pageNo: 1,
  });
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const loadClassRooms = () => {
    let reqObj = {};
    reqObj.condition = { companyId: global_var.company_id, activeFlag: 1 };
    reqObj.projection = { className: 1, classCourseConfig: 1, fkClassRoomMasterId: 1 ,classAlias: 1};
    if (global_var.academicYearId) {
      reqObj.condition['academicYear'] = global_var.academicYearId
    }
    if (global_var.role_id === global_var.TEACHER_ROLE_ID) {
      reqObj.restrictClasses = true;
    }
    reqObj.rmId = global_var.roleMappingId;
    loadClassRoomDetails(reqObj)
      .then((response) => {
        let classes = JSON.parse(response.data);
        classes.forEach((class_) => {
          class_['_id'] = (class_['_id']['$oid'] ? class_['_id']['$oid'] : class_['_id']);
        });
        setClasses(classes); // Update the state with class data
      });
  };

  const loadDivisions = (selectedClass) => {
    let divisionCondition = {
      companyId: global_var.company_id,
      classroomId: selectedClass,
      activeFlag: 1,
      rmId: global_var.roleMappingId
    };
    if (global_var.academicYearId) {
      divisionCondition['academicYear'] = global_var.academicYearId
    }
    let divisions = [];
    getDivisionDetails(divisionCondition)
      .then((response) => {
        if (response.data.statusCode === 200) {
          divisions = response.data.divisions;
          setDivisions(divisions);
        } else {
          message.error(response.data.message);
        }

      });
  };

  useEffect(() => {
    loadClassRooms();
  }, []);

  useEffect(() => {
    filtersChanged(filters);
  }, [filters, filtersChanged]);

  return (
    <>
      <Row className="mb-2" gutter={[16, 16]}>
        <Col span={8}>
          <Input.Search
            bordered={false}    
            placeholder={
              searchBoxPlaceHolder
                ? searchBoxPlaceHolder
                : global_var.role_id === global_var.STUDENT_ROLE_ID
                  ? "Search Lab Assignment name"
                  : null
            }
            onSearch={(searchKey) => {
              setFilters({
                ...filters,
                projectName: searchKey,
                studentName: searchKey,
                pageNo: 1,
              });
            }}
            style={{ width: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
          />
        </Col>

        {!hideAssignmentTypeFilter && (
          <Col span={4}>
            <Select
              bordered={false}
              style={{ minWidth: "95%",border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
              onChange={(projectStack) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  projectLanguage: projectStack,
                });
              }}
              placeholder="Filter by Project type"
              allowClear={true}
              options={[
                {
                  label: "Programming Languages",
                  options: [
                    { label: "Python", value: "python" },
                    { label: "Html", value: "html_css" },
                  ],
                },
                {
                  label: "Visual Coding",
                  options: [
                      { label: "Visual Coding 3", value: "vc3" },
                  ],
                },
                {
                  label: "Database",
                  options: [{ label: "SQL", value: "sql2" }],
                },
              ]}
            />
          </Col>
        )}

        {!hideProjectStatusFilter && (
          <Col xs={8} sm={8} md={4} lg={4} xl={4}>
            <Select
              bordered={false}             
              allowClear={true}
              style={{
                minWidth: "95%",
                border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by status"
              onChange={(selectedStatus) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  evaluationStatus: selectedStatus,
                });
              }}
              options={[
                {
                  label: "Evaluated",
                  value: "Evaluated",
                },
                {
                  label: "Asked to resubmit",
                  value: "Ask for resubmission",
                },
                {
                  label: "Submitted",
                  value: "submittedForEvaluation",
                },
              ]}
            />
          </Col>
        )}

      </Row>

      <Row className="mb-2">
        {!hideClassFilter && (
          <Col span={4}>
            <Select
              bordered={false}    
              allowClear={true}
              style={{
                minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by class"
              onChange={(selectedClass) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkClassId: selectedClass,
                  fkDivisionId: null,  // Set a fkDivisionId null to clear old divion id
                });
                if (selectedClass) {
                  loadDivisions(selectedClass);
                  setSelectedDivision(null);
                } else {
                  setDivisions([]);
                  setSelectedDivision(null);
                }
              }}
              options={classes.map((class_) => ({
                label: class_.classAlias,
                value: class_._id,
              }))}
            />
          </Col>
        )}
        {!hideDivisionFilter && (
          <Col span={4}>
            <Select
              bordered={false}    
              allowClear={true}
              style={{
                minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by division"
              value={selectedDivision} // Set the selected division 
              onChange={(selectedDivisions) => {
                setSelectedDivision(selectedDivisions);
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkDivisionId: selectedDivisions,
                });
              }}
              options={divisions.map((division_) => ({
                label: division_.divisionName,
                value: division_._id,
              }))}
            />
          </Col>
        )}
      </Row>

      <Row className="mb-2 text-end">
        <Col span={24}>
          <div style={{ display: 'inline-block', border: '1px solid #FFECD2',borderRadius:'5px',padding:'1px'}}>
            <Pagination className="cs-pagination"
              defaultPageSize={12}
              showSizeChanger={false}
              total={totalLabQuestionsCount}
              current={filters.pageNo}
              onChange={(pageNo) => {
                setFilters({
                  ...filters,
                  pageNo: pageNo,
                });
              }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LabAssignmentFilters;
